import { get, put } from './requests.js'

const ENTITY = 'pdp-audience-notification-rules'

// The rule fields are single words, so the camelize/decamelize round trip would
// be a no-op on them but would rewrite the crud bookkeeping fields it carries
// alongside. Leaving the payload alone keeps what is saved identical to what was
// loaded.
const CONFIG = { transformPayload: false }

export const getRule = (id) => get([ENTITY, id], CONFIG)

export const updateRule = (id, data) => put([ENTITY, id], CONFIG, data)

// Which audience a rule set would notify, without approving or sending anything.
export const getRecipientPreview = (audienceId) =>
  get([ENTITY, 'preview'], CONFIG, { audience_id: audienceId })

// datasphere-api pins the APA host to its own deploy environment, so production
// lists production organizations and dev can only ever reach dev.
export const getPdpOrganizations = (env) =>
  get(['organizations-apa'], { ...CONFIG, removeTrailingSlash: true }, { env, fields: 'name' })
